import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import ButtonStyle from 'Flow2/components/UI/Button/Button.module.scss';
import classes from './InfoSection.module.scss';
import customClasses from "Flow2/components/CustomCollections/CustomBox/CustomTableBox/CustomTableBox.module.scss";
import * as actions from "store/actions/index";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faArrowDown, faEllipsisV, faEnvelope, faFilePdf, faFile } from '@fortawesome/free-solid-svg-icons';
import audioImage from 'Flow2/components/CustomCollections/CustomImages/audio.png';
import FlexRow from 'Flow2/components/UI/Container/FlexRow';
import FlexColumn from 'Flow2/components/UI/Container/FlexColumn';
import Button from 'Flow2/components/UI/Button/Button';
import CustomDataPage from 'Flow2/pages/CustomDataPage/CustomDataPage';
import * as Controls from 'Flow2/config/Controls';
import * as metadata from 'Flow2/containers/Masterdata/Masterdata';
import StructureMapping from 'Flow2/util/StructureMapping.js';
import MetadataElementHelper from 'Flow2/util/MetadataElementHelper.js';
import CustomFlexListBox from 'Flow2/components/CustomCollections/CustomBox/CustomFlexListBox/CustomFlexListBox';
import * as CustomTable from 'Flow2/components/CustomCollections/CustomBox/CustomTableBox/CustomTableBox';
import { isOdd, updateHistoryData, refreshCurrentData, subStringAfter }
    from "Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil";
import CustomEvents from 'Flow2/components/CustomCollections/CustomDataConfig/CustomAppEvents';
import CustomTypes from "Flow2/components/CustomCollections/CustomDataConfig/CustomDataTypes";
import { CustomAppEventListener, isNLW, isFrancetv, isPMDB, isPorscheArchiv, isTdk }
    from 'Flow2/components/CustomCollections/CustomDataControllers/CustomAppController';
import { injectIntl, FormattedMessage } from 'react-intl';
import Swal from 'sweetalert2';
import MediaFile from 'Flow2/util/MediaFile.js';
import SourcefileMetadata from 'Flow2/components/SourcefileMetadata/SourcefileMetadata';
import { format } from 'date-fns';
import PH from 'Flow2/util/MetadataPermissionHelper.js';

import { CHAPTER_MARK } from 'Flow2/components/VideoPlayer/ChapterPlayer';
import { sortSourceFile } from 'Flow2/components/AdvancedBox/AdvancedHelpers/FileHelper';

import * as ids from 'Flow2/config/Components';
import { GetComponent } from 'Flow2/util/ComponentLoader';

const MEDIA_COLUMNS_DEFAULT = ["type", "id", "resolution", "filesize", "aspectratio", "format", "purpose", "actions"];

export const MediaElement = (props) => {
    let mainUrl = props.mainUrl ? `${props.mainUrl}&width=125&height=70&${new Date().getTime()}` : false;
    //let mainUrl = props.mainUrl ? `${props.mainUrl}` : false;

    //console.log(props);

    let videoRef = null;
    if (props.mediatype === 'video') {
        videoRef = React.createRef();
        props.videoRefs.push(videoRef);
    }

    const getIcon = () => {
        if (!MediaFile.isPlayable(props.file)) {
            let ext = MediaFile.getFileExtention(props.file.getFilename());
            ext = ext ? (<span className={classes.Ext}>{ext.toUpperCase()}</span>) : "";
            return (
                <>
                    <FontAwesomeIcon className={classes.Icon} icon={faFile} title={props.file.getFilename()} />
                    {ext}
                </>
            );
        }
        if (props.mediatype === 'video') {
            let video = MediaFile.localURL() + props.file.getUrl();
            if (video) {
                if (props.config._TOKEN_) {
                    video += "?token=" + props.config._TOKEN_;
                } else {
                    //video += "#1.0";
                }
            }
            return (
                <video
                    ref={videoRef} /*controls='controls'*/
                    type='video/mp4'
                    preload='metadata'
                    controlsList={props.download} >
                    <source src={video} ></source>
                </video>
            );
        }
        if (props.mediatype === 'image' || props.mediatype === 'pictures') {
            return (
                <img
                    alt=""
                    onDoubleClick={() => props.dblClick(MediaFile.localURL() + props.file.getUrl())}
                    className={"pointer"}
                    src={MediaFile.localURL() + props.file.getUrl()} />
            );
        }
        if (props.mediatype === 'audio') {
            return (
                <img
                    alt=""
                    className=""
                    src={mainUrl ? mainUrl : audioImage} />
            );
        }
        if (props.mediatype === 'other') {
            return (
                <img
                    alt=""
                    className=""
                    src={mainUrl ? mainUrl : CustomAppEventListener("getMfData", props.file, "icon")} />
            );
        }
    }

    return (
        <div className={classes.clip} >
            {(props.getMediafileIcon && props.getMediafileIcon(props)) || getIcon()}
        </div>
    )
}


class MediaFileSection extends Component {

    defaultPurpose = ["preview", "mp4_576p", "mp4_720p", "mp4_1080p"];

    structures = {};

    constructor(props) {
        super(props);

        this.state = {
            showMediaFiles: props.config.showMediaFileInfoSection || false,
            id: 0,
            mediafiles: this.createMediafiles(props.clip.mediafiles),
            shouldUpdate: false,
            sortMfObj: {},
            dColumns: [...MEDIA_COLUMNS_DEFAULT]
        };

        this.videoRefs = [];
    }


    refreshCustomSorting = (mediafiles) => {
        if (!isFrancetv()) {
            let defaultName = "language";
            let sorted = true;
            if (isTdk()) {
                defaultName = "filesize";
                sorted = false;
            }
            //data, name, sorted, appLang
            let sortedMfiles = CustomTable.getMfSortedData({
                data: mediafiles, name: defaultName,
                sorted, appLang: this.props.language, tempConfig: this.props.tempConfig
            });
            if (isTdk() && sortedMfiles) {
                sortedMfiles = sortSourceFile({ sortedList: sortedMfiles });
            }
            this.setState({ sortMfObj: { ...this.state.sortMfObj }, shouldUpdate: true, sortedMfiles });
        }
    }

    componentDidMount = () => {
        this.refreshCustomSorting(this.props.clip.mediafiles);
        this.getMfListColumns();
    }

    toggleMediaFiles = () => {
        this.setState({ showMediaFiles: !this.state.showMediaFiles });
    }

    getMediaType = (file) => {
        let fileExt = file.getFilename().split('.').pop().toLowerCase(),
            videoFormats = ['mp4', 'mov', 'flv', 'mxf'],
            imageFormats = ['jpg', 'jpeg', 'png', 'tiff', 'tif'];
        // docsFormats = ['doc', 'docx', 'xls', 'xlsm', 'pdf', 'ppt'];
        let audioFormats = CustomAppEventListener("getMfData", file, "audioFormats");
        if (videoFormats.indexOf(fileExt) !== -1) {
            return 'video';
        } else if (imageFormats.indexOf(fileExt) !== -1) {
            return 'image';
        }
        else if ((audioFormats.indexOf(fileExt) !== -1)) {
            return 'audio';
        }
        else {
            return 'other';
        }
    }

    createMediafiles = (mediafiles) => {
        let allMediafiles = {};

        mediafiles.forEach((file) => {
            allMediafiles[file.id] = this.createMediafile(file, file.tags);
        });

        return allMediafiles;
    }

    createMediafile = (file, tags) => {
        let mediafile = {
            id: "MF" + file.id,
            language: "",
            subtitle: "",
            purpose: "",
            tags: tags || "",
            info: MediaFile.getInformation(file)
        }

        let result = {};

        if (tags) {
            // extract languages
            result = this.createLanguages(mediafile.tags);
            mediafile = Object.assign({}, mediafile, result);

            // extract subtitles
            result = this.createSubtitles(mediafile.tags);
            mediafile = Object.assign({}, mediafile, result);

            // extract purpose
            result = this.createPurpose(mediafile.tags);
            mediafile = Object.assign({}, mediafile, result);
        }

        return mediafile;
    }

    createLanguages = (tags) => {
        if (!tags) {
            return { tags: tags, language: "" };
        }

        tags = tags.replace(new RegExp(';', 'g'), ',');

        const langs = [];
        const notUsedTags = [];
        const tagArray = tags.split(',');

        tagArray.forEach((tag) => {
            if (tag.length === 2) {
                langs.push(tag);
            } else {
                notUsedTags.push(tag);
            }
        });

        return { tags: notUsedTags.join(','), language: langs.join(';') };
    }

    createSubtitles = (tags) => {
        if (!tags) {
            return { tags: tags, subtitle: "" };
        }

        tags = tags.replace(new RegExp(';', 'g'), ',');

        const subtitles = [];
        const notUsedTags = [];
        const tagArray = tags.split(',');

        tagArray.forEach((tag) => {
            if (tag.length === 5 && tag.indexOf('stl') !== -1) {
                subtitles.push(tag.replace('stl', ''));
            } else {
                notUsedTags.push(tag);
            }
        });

        return { tags: notUsedTags.join(','), subtitle: subtitles.join(';') };
    }

    createPurpose = (tags) => {
        if (!tags) {
            return { tags: tags, purpose: "" };
        }

        tags = tags.replace(new RegExp(';', 'g'), ',');

        // !!!
        // U NEED TO HAVE A LOOK AT THE MetadataConfig SECTION mediafile FIELD purpose
        // !!!

        const values = this.props.config.MEDIAFILE_PURPOSE_VALUES || this.defaultPurpose;/*["thumb_newstv", "timedvod", "thumb_newsroom", "socialmedia", "mp4_288p", "mp4_576p", "mp4_720p", "mp4_1080p"];*/
        const purposes = [];
        const notUsedTags = [];
        const tagArray = tags.split(',');

        tagArray.forEach((tag) => {
            if (values.includes(tag)) {
                purposes.push(tag);
            } else {
                notUsedTags.push(tag);
            }
        });
        return { tags: notUsedTags.join(','), purpose: purposes.join(';') };
    }

    editHandler = (file) => {
        this.structures.checkbox = StructureMapping.createCheckboxStructure("mediafile", this.state.mediafiles[file.id]);
        this.setState({ id: file.id });
    }

    customCheckAndUpdateMf = () => {
        let mustChange = null;
        if (this.state.mediafiles) {
            if (this.state.mediafiles[this.state.id] && this.state.mediafiles[this.state.id].purpose
                && this.state.mediafiles[this.state.id].purpose.includes("master_thumb")) {
                // set mainthumbnail
                this.props.setThumbnail(this.state.id, this.props.clip.id);
                for (let item in this.state.mediafiles) {
                    if ((item != this.state.id)
                        && (this.state.mediafiles[item].purpose && this.state.mediafiles[item].purpose.includes("master_thumb"))) {
                        mustChange = item;
                        break;
                    }
                }
                if (mustChange) {
                    let newTags = '';
                    this.props.clip.mediafiles.forEach(item => {
                        if (item.data.id == mustChange) newTags = item.data.tags;
                    })
                    newTags = newTags.replace(",master_thumb", ',thumbnail');
                    newTags = newTags.replace("master_thumb", 'thumbnail');
                    this.props.editMediaFile(mustChange, { tags: newTags }, this.props.clip.id);
                }
            }
        }
    }

    removeTagAndUpdateMf = (section, value) => {
        if (this.state.mediafiles) {
            if (this.state.mediafiles[this.state.id]
                && this.state.mediafiles[this.state.id][section]
                && this.state.mediafiles[this.state.id][section].includes(value)) {

                for (let item in this.state.mediafiles) {
                    if ((item != this.state.id)
                        && (this.state.mediafiles[item][section]
                            && this.state.mediafiles[item][section].includes(value))) {

                        this.props.clip.mediafiles.forEach(mf => {
                            if (mf.data.id == item && mf.data.tags) {
                                let tags = mf.data.tags.replace(new RegExp(';', 'g'), ',');
                                tags = tags.split(',');
                                tags = tags.filter(tag => tag !== value);
                                this.props.editMediaFile(mf, { tags: tags.join(',') }, this.props.clip.id);
                            }
                        })
                    }
                }
            }
        }
    }

    saveHandler = () => {

        if (isNLW()) {
            //check Thumbnail Primary
            this.customCheckAndUpdateMf();
        }

        if (isPMDB()) {
            this.removeTagAndUpdateMf("purpose", "thumb_newstv");
        }

        let tags = this.state.mediafiles[this.state.id].tags;

        if (this.state.mediafiles[this.state.id].language) {
            tags += "," + this.state.mediafiles[this.state.id].language.replace(new RegExp(';', 'g'), ',');
        }
        if (this.state.mediafiles[this.state.id].subtitle) {
            if (this.state.mediafiles[this.state.id].subtitle.replace('0', '')) {
                tags += ",stl" + this.state.mediafiles[this.state.id].subtitle.replace(new RegExp(';', 'g'), ',');
            }
        }
        if (this.state.mediafiles[this.state.id].purpose) {
            if (this.state.mediafiles[this.state.id].purpose.replace('0', '')) {
                tags += "," + this.state.mediafiles[this.state.id].purpose.replace(new RegExp(';', 'g'), ',');
            }
        }

        if (tags.indexOf(',') === 0) {
            tags = tags.replace(',', '');
        }

        this.props.editMediaFile(this.state.id, { tags: tags }, this.props.clip.id);

        this.structures.checkbox = {};
        this.setState({ id: 0 });
    }

    changeHandler = (elements) => {
        const mediafiles = this.state.mediafiles;
        for (let element in elements) {
            mediafiles[this.state.id][element] = elements[element];
        }

        this.setState({ mediafiles: mediafiles });

        // callback in calling component (parent) 
        if (this.props.onChangeHandler) {
            //this.props.onChangeHandler({ ...elements });
        }
    }

   

    deleteHandler = (id, clipId) => {
        Swal.fire({
            title: this.props.intl.formatMessage({ id: "popup.infoSection.mediafile.title" }),
            text: this.props.intl.formatMessage({ id: "popup.infoSection.mediafile.message" }),
            showCancelButton: true,
            cancelButtonText: this.props.intl.formatMessage({ id: "common.close" }),
            confirmButtonText: this.props.intl.formatMessage({ id: "common.ok" }),
            confirmButtonClass: [ButtonStyle.Button, ButtonStyle.Red].join(' '),
            cancelButtonClass: [ButtonStyle.Button, ButtonStyle.White].join(' '),
            buttonsStyling: false
        }).then((result) => {
            if (result.value) {
                this.props.deleteMediaFile(id, clipId);
                //data for history
                if (clipId && id) {
                    if (isPMDB() || isFrancetv()) {
                        if (this.props.customHistory.showHistory && this.props.customHistory.showHistory.clipid) {
                            let curAction = this.isMainThumb(id) ? CustomTypes.THUMB_DELETE : CustomTypes.MASTER_DELETE;
                            let updatedHistory = updateHistoryData(this.props.user.id, curAction);
                            let currentData = refreshCurrentData(this.props.customHistory.showHistory, updatedHistory);
                            if (updatedHistory) this.props.updateMetadata("clip", clipId, { history: updatedHistory });
                            if (currentData) this.props.setCustomHistory({ showHistory: { ...currentData } });
                        }
                    }
                }
            }
        });
    }

    downloadHandler = (file) => {
        let url = file.getUrl();
        if (url) {
            if (this.props.config._TOKEN_) {
                url += "?token=" + this.props.config._TOKEN_;
            }
            //window.location = url;
            window.open(url, '_blank');
            Swal.fire({
                title: this.props.intl.formatMessage({ id: "toast.title.download" }),
                toast: true,
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true
            });
        }
    }

    onSetThumbnail = (id, clipId) => {
        Swal.fire({
            title: this.props.intl.formatMessage({ id: "popup.title.thumbnail.replace" }),
            text: this.props.intl.formatMessage({ id: "popup.message.thumbnail.replace" }),
            showCancelButton: true,
            cancelButtonText: this.props.intl.formatMessage({ id: "common.cancel" }),
            confirmButtonText: this.props.intl.formatMessage({ id: "common.ok" }),
            confirmButtonClass: [ButtonStyle.Button, ButtonStyle.Red].join(' '),
            cancelButtonClass: [ButtonStyle.Button, ButtonStyle.White].join(' '),
            buttonsStyling: false
        }).then((result) => {
            if (result.value) {
                this.props.setThumbnail(id, clipId);
                //HISTORY BEGIN
                if (isFrancetv()) {
                    let updatedHistory = updateHistoryData(this.props.user.id, CustomTypes.MASTER_THUMB_IMAGE);
                    let currentData = refreshCurrentData(this.props.customHistory.showHistory, updatedHistory);
                    if (updatedHistory) this.props.updateMetadata("clip", clipId, { history: updatedHistory });
                    if (currentData) this.props.setCustomHistory({ showHistory: { ...currentData } });
                }
                //HISTORY END
            }
        });
    }

    sendLink = (file) => {
        let url = 'mailto:?subject=Mediafile download&body=' + file.getUrl();
        if (isPMDB()) url = 'mailto:?subject=Mediafile download&body=https:' + file.getUrl();
        // window.location.href = 'mailto:?subject=Mediafile download&body=' + file.getUrl();
        window.location.href = url;
    }

    showMediaFileBtn = () => {
        const { granting } = this.props.user;
        let showPopUp = true;
        if (isFrancetv() && granting && granting.udo
            && (typeof granting.udo.seemediadata != 'undefined' && granting.udo.seemediadata == false)) {
            showPopUp = false;
        }

        return showPopUp;
    }

    showMediaFileDetails = (dataObj) => {
        if (dataObj && dataObj.data) {
            let filteredObj = { ...dataObj.data };
            for (let item in filteredObj) {
                if (!filteredObj[item]) delete filteredObj[item];
                if (item === "created_time") {
                    let time = parseInt(filteredObj[item])
                    if (time) filteredObj[item] = format(new Date(time * 1000), 'dd.MM.yyyy HH:mm:ss');
                }
                if (this.allowDownload({ dataObj })) {
                    if (item === "url" && !filteredObj[item].includes("https:") && !filteredObj[item].includes("http:"))
                        filteredObj[item] = "https:" + filteredObj[item];
                } else {
                    delete filteredObj["url"];
                    delete filteredObj["path"];
                }
            }
            if (filteredObj && filteredObj.url
                && (filteredObj.url.includes(".jpg") || filteredObj.url.includes(".jpeg"))
                && ((filteredObj.containerformat && filteredObj.containerformat.toLowerCase() !== 'jpg') || !filteredObj.containerformat)
            ) {
                filteredObj.containerformat = "JPG";
            }
            let data = Object.entries(filteredObj);
            if (data && data.length > 0) {
                let dataTable = CustomAppEventListener(CustomEvents.SHOW_MF_INFO, data, this.props.intl.formatMessage);
                Swal.fire({
                    title: "Mediafile Info",
                    html: dataTable,
                    confirmButtonText: this.props.intl.formatMessage({ id: "common.close" }),
                    confirmButtonClass: [ButtonStyle.Button, ButtonStyle.Red].join(' '),
                    cancelButtonClass: [ButtonStyle.Button, ButtonStyle.White].join(' '),
                    buttonsStyling: false
                });
            }
        }
    }

    getThumbnail = () => {
        if (!this.props.clip.mainthumbnail || !this.props.config.SHOW_MEDIAFILE_THUMBNAIL) {
            return "";
        }

        return (
            <div className="FlexMfListRow" style={{ "--percentage": "10%" }}>
                <div className={customClasses.CustomFlexTableMfColumnFixed}>
                    <div className={classes.clip} >
                        <img key={this.props.clip.mediafiles.length} alt="" onDoubleClick={null/*() => this.props.dblClick(this.props.clip.mainthumbnail)*/}
                            className="" src={this.props.clip.mainthumbnail + "&width=125&height=125&" + new Date().getTime()} />
                    </div>
                </div>
                <div className={customClasses.CustomFlexTableMfColumn}>
                    {this.props.intl.formatMessage({ id: "common.thumbnail" })}
                </div>
            </div>
        );
    }

    showMore = (file) => {
        const { MF_SHOWMORE } = this.props.config;
        if (file.tags && MF_SHOWMORE) {
            let showItems = file.tags.split(",").filter(item => MF_SHOWMORE[item]).map(item => MF_SHOWMORE[item])
            if (showItems && showItems.length) return showItems.join(" ");
        }
        return null;
    }

    showAspectRatio = (file) => {
        let regex = /crop_\d?.?\dx\d?.?\d/i;
        if (file && file.tags) {
            let found = file.tags.match(regex);
            if (found) {
                let ratio = subStringAfter(found[0], 'crop_');
                if (ratio) ratio = ratio.replace("x", ":");
                return ratio;
            }
        }
        return '';
    }
    //LAMTEST BEGIN

    getMfListColumns = () => {
        let dColumns = this.state.dColumns;
        if (isFrancetv()) dColumns = dColumns.filter(item => item !== "purpose");
        if (this.props.config.showFlexColumns
            && this.props.config.showFlexColumns.length > 0) {
            dColumns = this.props.config.showFlexColumns;
        }
        this.setState({ dColumns });
    }

    showFileIDBox = ({ id, file, p }) => {
        return (
            <div className={customClasses.CustomFlexTableMfColumn} style={{ "--percentage": `${p}%` }} >
                {this.getOutput(id, "id")}<br />
                {this.isMainThumb(file) ? (
                    <FontAwesomeIcon className={classes.Icon} icon="image"
                        title={this.props.intl.formatMessage({ id: "common.thumbnail" })} />
                ) : ""}
                {(this.props.mediafile && this.props.mediafile.id === file.id) ? (
                    <FontAwesomeIcon className={classes.Icon} icon="play"
                        title={this.props.intl.formatMessage({ id: "common.playing" })} />
                ) : ""}
                {CustomAppEventListener("getMfData", file, "cut")}
            </div>
        )
    }

    showResolution = ({ id, p }) => {
        return (
            <div className={customClasses.CustomFlexTableMfColumn} style={{ "--percentage": `${p}%` }} >
                {CustomTable.convertMfInfo(this.getOutput(id, "info"), "resolution")}
            </div>
        )
    }

    showFileSize = ({ id, p }) => {
        return (
            <div className={customClasses.CustomFlexTableMfColumn} style={{ "--percentage": `${p}%` }} >
                {CustomTable.convertMfInfo(this.getOutput(id, "info"), "filesize")}
            </div>
        )
    }

    showAspRatioInfo = ({ id, file, dataRate, p }) => {
        return (
            <div className={customClasses.CustomFlexTableMfColumn} style={{ "--percentage": `${p}%` }} >
                {this.showAspectRatio(file) ? this.showAspectRatio(file)
                    : CustomTable.convertMfInfo(this.getOutput(id, "info"), "aspectratio")}
                <br />{dataRate}
            </div>
        )
    }

    showCodec = ({ id, file, p }) => {
        let containerFormat = file.containerformat ? file.containerformat : null;
        let audioCodec = file.audiocodec ? file.audiocodec : "-";
        let videoCodec = file.videocodec ? file.videocodec : "-";
        return (
            <div className={customClasses.CustomFlexTableMfColumn} style={{ "--percentage": `${p}%` }} >
                {containerFormat ? containerFormat
                    : CustomTable.convertMfInfo(this.getOutput(id, "info"), "format")}<br />{videoCodec}<br />{audioCodec}
            </div>
        )
    }

    showPurpose = ({ id, file, source, p }) => {
        if (!isFrancetv()) {
            return (
                <div style={{ "--percentage": `${p}%` }} className={isNLW() ? customClasses.CustomFlexTableMfColumnBold : customClasses.CustomFlexTableMfColumn}>
                    {source}{this.showMore(file)}{this.getOutput(id, "purpose")}{CustomAppEventListener("getMfData", file, "additionalPurpose")}
                </div>)
        }
    }

    showLanguage = ({ id, p }) => {
        if (!isFrancetv()) {
            return (
                <div style={{ "--percentage": `${p}%` }} className={customClasses.CustomTableMfColumnFixed}>
                    {this.getOutput(id, "language")}
                </div>)
        }
    }

    showSubtitle = ({ id, p }) => {
        if (!isFrancetv()) {
            return (
                <div style={{ "--percentage": `${p}%` }} className={customClasses.CustomTableMfColumnFixed}>
                    {this.getOutput(id, "subtitle")}
                </div>)
        }
    }


    showMediaBox = ({ file, mainUrl }) => {
        const CustomMediaElement = GetComponent(ids.MEDIAFILE_MEDIA_ELEMENT, MediaElement);
        return (
            <div className={customClasses.CustomFlexTableMfColumnFixed}>
                <CustomMediaElement
                    {...this.props}
                    key={file.id}
                    download={this.canDownload()}
                    file={file}
                    mediatype={this.getMediaType(file)}
                    mainUrl={mainUrl}
                    videoRefs={this.videoRefs}
                />
            </div>
        )
    }

    allowDownload = ({ file }) => {
        // comes for porschearchiv
        if (isPorscheArchiv()) {
            if (!PH.hasFieldPermission({ ...this.props, originalObject: this.props.clip.originalObject, type: metadata.OBJECT_TYPE_CLIP }, "*", "download")) {
                return false;
            }
        }

        if (PH.hasFieldPermission({
            ...this.props, originalObject: this.props.clip.originalObject,
            type: metadata.OBJECT_TYPE_CLIP
        }, "*", "download")) {
            return true;
        }
        return PH.hasMfDownloadPermission({ ...this.props, originalObject: this.props.clip.originalObject }, file);
    }

    renderDeleteButton = (file, counter) => {
        if (!PH.hasPermission({ ...this.props, originalObject: this.props.clip.originalObject, type: metadata.OBJECT_TYPE_CLIP })) {
            return "";
        }

        // comes for porschearchiv
        if (isPorscheArchiv()) {
            if (!PH.hasDeletePermission({ type: metadata.OBJECT_TYPE_CLIP, ...this.props })) {
                return "";
            }
        }

        if (!PH.hasFieldPermission({ user: this.props.user, originalObject: this.props.clip.originalObject, type: metadata.OBJECT_TYPE_CLIP }, "*", "delete")) {
            return "";
        }

        return (
            <div className={isOdd(counter) ? customClasses.CustomFlexTableMfIconRound
                : customClasses.CustomTableMfIconRound} onClick={() => this.deleteHandler(file, this.props.clip.id)}>
                <FontAwesomeIcon className={customClasses.CustomTableMfIcon} icon={faTrash}
                    title={this.props.intl.formatMessage({ id: "common.delete" })} />
            </div>
        );
    }

    renderEditButton = (file, counter) => {
        if (!PH.hasPermission({ ...this.props, originalObject: this.props.clip.originalObject, type: metadata.OBJECT_TYPE_CLIP }) || !PH.showControl(this.props.config, Controls.CTL_MEDIAFILE_EDIT)) {
            return "";
        }

        // comes for porschearchiv
        if (isPorscheArchiv()) {
            if (!PH.hasDeletePermission({ type: metadata.OBJECT_TYPE_CLIP, ...this.props })) {
                return "";
            }
        }

        if (!PH.hasFieldPermission({ user: this.props.user, originalObject: this.props.clip.originalObject, type: metadata.OBJECT_TYPE_CLIP }, "*", "delete")) {
            return "";
        }

        return this.getIcon(file, isOdd(counter));
    }

    showActionIcons = ({ file, isOdd, counter, p }) => {
        /*let downloadHandler = () => {
            this.downloadHandler(file);
        }*/

        let downloadHandler = () => {
            this.downloadHandler(file);
        }

        if (this.props.downloadHandler) {
            downloadHandler = () => this.props.downloadHandler(this.props.downloadProps, this.props.clip, file);
        }
        if (this.props.useDefaultDownloadHandler && this.props.useDefaultDownloadHandler(this.props.clip, file)) {
            downloadHandler = () => this.downloadHandler(file);
        }

        return (
            <div style={{ "--percentage": `${p}%`, minWidth: "220px" }} className={customClasses.CustomFlexTableMfColumnFixed}>
                <div className={[customClasses.CustomFlexTableMfIconBox, classes.IconBox].join(' ')}>
                    <SourcefileMetadata style="icon" />
                    {/* {
                        isPorscheArchiv() && (
                            <div className={isOdd(counter) ? customClasses.CustomFlexTableMfIconRound
                                : customClasses.CustomTableMfIconRound} onClick={() => console.log("LOGS: LAMTEST OCR")}>
                                <FontAwesomeIcon className={customClasses.CustomTableMfIcon} icon={faFilePdf} title="OCR" />
                            </div>
                        )
                    } */}
                    {
                        this.allowDownload({ file }) ?
                            <div className={isOdd(counter) ? customClasses.CustomFlexTableMfIconRound
                                : customClasses.CustomTableMfIconRound} onClick={() => downloadHandler()}>
                                <FontAwesomeIcon className={customClasses.CustomTableMfIcon} icon={faArrowDown} title="Download" />
                            </div> : ""
                    }
                    {
                        (PH.hasPermission({ ...this.props, originalObject: this.props.clip.originalObject, type: metadata.OBJECT_TYPE_CLIP }) && this.props.config.SHOW_MEDIAFILE_THUMBNAIL && MediaFile.isImage2(file)) ?
                            <div className={isOdd(counter) ? customClasses.CustomFlexTableMfIconRound
                                : customClasses.CustomTableMfIconRound} onClick={() => this.onSetThumbnail(file.id, this.props.clip.id)}>
                                <FontAwesomeIcon className={customClasses.CustomTableMfIcon} icon="image"
                                    title={this.props.intl.formatMessage({ id: "mediafile.thumbnail.replace" })} />
                            </div> : ""

                    }

                    {this.renderSetMediafile(file, counter)}
                    {
                        PH.hasGranting(this.props, "sendmedialink", true) ? isPorscheArchiv() && !PH.hasFieldPermission({ ...this.props, originalObject: this.props.clip.originalObject, type: metadata.OBJECT_TYPE_CLIP }, "*", "download") ? "" :
                            <div className={isOdd(counter) ? customClasses.CustomFlexTableMfIconRound
                                : customClasses.CustomTableMfIconRound} onClick={() => this.sendLink(file)}>
                                <FontAwesomeIcon className={customClasses.CustomTableMfIcon} icon={faEnvelope} title="Send Link" />
                            </div> : ""
                    }
                    {
                        /*PH.hasPermission({ ...this.props, originalObject: this.props.clip.originalObject, type: metadata.OBJECT_TYPE_CLIP })
                            && PH.showControl(this.props.config, Controls.CTL_MEDIAFILE_EDIT) ? this.getIcon(file, isOdd(counter)) : ""
                        */
                        this.renderEditButton(file, counter)
                    }
                    {
                        /*PH.hasPermission({ ...this.props, originalObject: this.props.clip.originalObject, type: metadata.OBJECT_TYPE_CLIP }) ?
                            <div className={isOdd(counter) ? customClasses.CustomFlexTableMfIconRound
                                : customClasses.CustomTableMfIconRound} onClick={() => this.deleteHandler(file, this.props.clip.id)}>
                                <FontAwesomeIcon className={customClasses.CustomTableMfIcon} icon={faTrash}
                                    title={this.props.intl.formatMessage({ id: "common.delete" })} />
                            </div> : ""*/
                        this.renderDeleteButton(file, counter)
                    }

                    {this.showMediaFileBtn() ? <div className={isOdd(counter) ? customClasses.CustomFlexTableMfIconRound
                        : customClasses.CustomTableMfIconRound} onClick={() => this.showMediaFileDetails(file)}>
                        <FontAwesomeIcon className={customClasses.CustomTableMfIcon} color="red" icon={faEllipsisV} />
                    </div> : <div />}
                </div>
            </div>
        )
    }


    showMediaColumns = ({ id, file, mainUrl, dataRate, counter, isOdd, source, dColumns }) => {
        let p = 100 / dColumns.length;
        return dColumns.map(item => {
            if (item === "type") return this.showMediaBox({ id, file, mainUrl, p });
            if (item === "id") return this.showFileIDBox({ id, file, p });
            if (item === "language") return this.showLanguage({ id, p });
            if (item === "subtitle") return this.showSubtitle({ id, p });
            if (item === "resolution") return this.showResolution({ id, p });
            if (item === "filesize") return this.showFileSize({ id, p });
            if (item === "aspectratio") return this.showAspRatioInfo({ id, file, dataRate, p });
            if (item === "format") return this.showCodec({ id, file, p });
            if (item === "purpose") return this.showPurpose({ id, file, source, p });
            if (item === "actions") return this.showActionIcons({ file, isOdd, counter, p });
        })

    }

    getCustomTableRow = (file, counter, id, dColumns) => {
        let dataRate = file.datarate ? file.datarate : "-";
        let mainUrl = null;
        let source = file.sourcefile && PH.showControl(this.props.config, Controls.CTL_MEDIAFILE_SOURCE)
            ? (<><span>Source</span><br /></>) : "";
        if (file.id === this.props.clip.mainmediafile.id) mainUrl = this.props.clip.mainthumbnail;

        let downloadHandler = () => {
            this.downloadHandler(file);
        }

        if (this.props.downloadHandler) {
            downloadHandler = () => this.props.downloadHandler(this.props.downloadProps, this.props.clip, file);
        }
        if (this.props.useDefaultDownloadHandler && this.props.useDefaultDownloadHandler(this.props.clip, file)) {
            downloadHandler = () => this.downloadHandler(file);
        }

        return (
            <CustomFlexListBox key={file.id} listName="mediafileItems" mfId={id} getOutput={this.getOutput}
                isOdd={isOdd(counter)} isSource={file.sourcefile} filename={file.filename}>
                {this.showMediaColumns({ id, file, mainUrl, dataRate, counter, isOdd, source, dColumns })}
            </CustomFlexListBox>);
    }
    //LAMTEST END

    getMediaFiles = ({ dColumns }) => {
        if (!this.props.clip.mainmediafile) {
            return "";
        }
        const files = [];
        let id = this.props.clip.mainmediafile.id;
        let counter = this.props.clip.mainthumbnail ? 1 : 0;

        if (this.state.shouldUpdate && this.state.sortedMfiles) {
            this.state.sortedMfiles.forEach(sortedFile => {
                this.props.clip.mediafiles.forEach((file) => {
                    id = file.id;
                    let tags = file.tags;

                    // do not show chapter mediafile in mediafile panel
                    if (!tags || tags && tags.indexOf(CHAPTER_MARK) === -1) {
                        if (parseInt(id) === parseInt(sortedFile.id)) {
                            files.push(this.getCustomTableRow(file, counter++, id, dColumns));
                        }
                    }

                });
            });

        } else {
            files.push(this.getCustomTableRow(this.props.clip.mainmediafile, counter++, id, dColumns));
            this.props.clip.mediafiles.forEach((file) => {
                if (parseInt(file.id) !== parseInt(this.props.clip.mainmediafile.id)) {
                    id = file.id;
                    let tags = file.tags;

                    // do not show chapter mediafile in mediafile panel
                    if (!tags || tags && tags.indexOf(CHAPTER_MARK) === -1) {
                        files.push(this.getCustomTableRow(file, counter++, id, dColumns));
                    }
                }
            });
        }

        return files;
    }

    renderSetMediafile = (file, counter) => {
        if (!this.props.mediafile) return "";
        if (!this.props.onSetMediafile) return "";
        if (!MediaFile.isPlayable(file) || (this.props.isPlayable && !this.props.isPlayable(file))) return "";
        if (this.props.mediafile.id === file.id) return "";

        return (
            <div className={isOdd(counter) ? customClasses.CustomFlexTableMfIconRound : customClasses.CustomTableMfIconRound} onClick={() => {
                let elm = document.getElementById('DetailViewContent');
                if (elm) { elm.scrollTop = 0; }
                this.props.onSetMediafile(file);
            }}>
                <FontAwesomeIcon className={customClasses.CustomTableMfIcon} icon="play" title={this.props.intl.formatMessage({ id: "infoSection.mediafile.change.player" })} />
            </div>
        );
    }

    isMainThumb = (file) => {
        if (!this.props.clip.mainthumbnail) {
            return false;
        }
        return this.props.clip.mainthumbnail.indexOf(file.data.filename) !== -1;
    }

    getIcon = (file, isOdd = false) => {
        if (file.id === this.state.id) {
            return (
                <div className={isOdd ? customClasses.CustomFlexTableMfIconRound
                    : customClasses.CustomTableMfIconRound} onClick={() => this.saveHandler(file)}>
                    <FontAwesomeIcon className={customClasses.CustomTableMfIcon} icon="save" title="Edit" />
                </div>
            )
        }
        return (
            <div className={isOdd ? customClasses.CustomFlexTableMfIconRound
                : customClasses.CustomTableMfIconRound} onClick={() => this.editHandler(file)}>
                <FontAwesomeIcon className={customClasses.CustomTableMfIcon} icon="pen" title="Edit" />
            </div>
        )
    }

    getOutput = (id, key) => {
        try {
            const element = MetadataElementHelper.createElement("mediafile", key, this.state.mediafiles[id][key]);
            if (!element) {
                return "";
            }

            if (this.showDisplayField(id, element, key)) {
                element.field = MetadataElementHelper.createDisplayField(element, this);
            } else {
                element.field = MetadataElementHelper.createEditField(element, this);
            }
            return element.field;
        } catch (err) {
            return "";
        }

    }

    showDisplayField = (id, element, key) => {
        if (this.state.id !== id) return true;
        if (StructureMapping.isReadonly(element.obj)) return true;
        return false;
    }

    onSortClick = (name) => {
        let isSorted = this.state.sortMfObj[`is${name}Sorted`] ? true : false;
        let sortedMfiles = CustomTable.getMfSortedData({
            data: this.props.clip.mediafiles, name,
            sorted: isSorted, appLang: this.props.language, tempConfig: this.props.tempConfig
        });
        this.setState({ sortMfObj: { ...this.state.sortMfObj, [`is${name}Sorted`]: !isSorted }, shouldUpdate: true, sortedMfiles });
    }

    canDownload = () => {
        // always disable download in player
        return "nodownload";

        /*if (!PH.hasFieldPermission({ user: this.props.user, originalObject: this.props.clip.originalObject, type: metadata.OBJECT_TYPE_CLIP }, "*", "download")) return "nodownload";
        if (!PH.showControl(this.props.config, Controls.CTL_DOWNLOAD)) return "nodownload";
        return "";*/
    }


    render() {
        //console.log(this.state);
        return (
            <FlexColumn className={[classes.InfoSection, "fullWidth"].join(' ')}>
                <FlexRow className={[classes.SectionHeader].join(' ')}>
                    <div className={classes.SectionHeaderHeadline}><FormattedMessage id="infoSection.mediafile.title" /></div>
                    <div className={[classes.SectionHeaderContent, 'text_ellipsis'].join(' ')}>{this.props.title}</div>
                    <div className={[classes.SectionHeaderButton, "pointer"].join(' ')} onClick={() => this.toggleMediaFiles()}>
                        {this.state.showMediaFiles ? <FontAwesomeIcon icon={"chevron-up"} /> : <FontAwesomeIcon icon={"chevron-down"} />}
                    </div>
                </FlexRow>
                <div className={this.state.showMediaFiles ? [classes.SectionBody].join(' ') : [classes.SectionBody, 'hidden'].join(' ')}>
                    {(isPorscheArchiv() && this.props.config.showFlexMediafiles) ? this.showFlexMfilesBox() : (
                        <CustomTable.CustomTableMf  >
                            <CustomFlexListBox isHeader={true} listName="mediafileItems" onSortClick={this.onSortClick}
                                sortMfObj={this.state.sortMfObj} dColumns={this.state.dColumns}>
                                {
                                    PH.hasPermission({ ...this.props, originalObject: this.props.clip.originalObject, type: metadata.OBJECT_TYPE_CLIP }) ?
                                        <CustomDataPage formDesign="MasterClipUpload" masterData={this.props.clip.metadata} /> :
                                        <Button btnType="Light" disabled="disabled"><FormattedMessage id="infoSection.mediafile.add" /></Button>
                                }
                            </CustomFlexListBox>
                            <CustomTable.CustomTableMfBody>
                                {this.getThumbnail()}
                                {this.getMediaFiles({ dColumns: this.state.dColumns })}
                            </CustomTable.CustomTableMfBody>
                        </CustomTable.CustomTableMf>
                    )}
                </div>
            </FlexColumn>
        )
    }

    componentWillReceiveProps(nextProps) {
        if (!nextProps.edit && !nextProps.loading) {
            if (this.state.shouldUpdate) {
                let sortMfObj = CustomTable.setMfInitState(this.state.sortMfObj);
                this.setState({ mediafiles: this.createMediafiles(nextProps.clip.mediafiles), shouldUpdate: false, sortMfObj });
            } else {
                this.setState({ mediafiles: this.createMediafiles(nextProps.clip.mediafiles) });
                // for Mediafiles Sorting
                this.refreshCustomSorting(nextProps.clip.mediafiles);
            }

        }
    }

    componentDidUpdate(prev) {
        this.videoRefs = this.videoRefs.filter((ref) => { return ref.current !== null });

        this.videoRefs.forEach(ref => {
            ref.current.oncontextmenu = (event) => {
                event.preventDefault();
            }
        });

    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        user: state.auth.user,
        loading: state.clipList.loading,
        language: state.ui.language,
        edit: state.mediafiles.loading,
        config: state.ui.config,
        tempConfig: state.ui.tempConfig,
        customHistory: state.customData.customHistory
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        deleteMediaFile: (id, clipId) => dispatch(actions.deleteMediaFile(id, clipId)),
        editMediaFile: (id, params, clipId) => dispatch(actions.editMediaFile(id, params, clipId)),
        setThumbnail: (id, clipId) => dispatch(actions.setThumbnail(id, clipId)),
        setCustomHistory: (currentHistory) => dispatch(actions.setCustomHistory(currentHistory)),
        updateMetadata: (type, id, metadata) => dispatch(actions.updateMetadata(type, id, metadata)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(injectIntl(MediaFileSection)));

